import draftActions from './draft-actions';
import { throttledFetchCategoryAttributeSuggestions } from './attributes-actions';
import { selectCategory } from 'tradera-state/views/syi/selectors/category-selectors';

export default {
    setShortDescription: shortDescription => (dispatch, getState) => {
        dispatch({
            type: 'SET_SHORT_DESCRIPTION',
            payload: shortDescription
        });
        dispatch(draftActions.updateDraftCanBeResumed());
        var featureSwitches = getState().environment.featureSwitches;
        if (featureSwitches['syi-attributes']) {
            dispatch(
                throttledFetchCategoryAttributeSuggestions(
                    selectCategory(getState()).draftCategoryId,
                    shortDescription
                )
            );
        }
    },
    reset: () => dispatch => {
        dispatch({
            type: 'RESET_SHORT_DESCRIPTION'
        });
        dispatch(draftActions.updateDraftCanBeResumed());
    }
};
